var sym = function sym(id) {
  id = "@@redux-saga/" + id;
  return typeof Symbol === 'function' ? Symbol(id) : id;
};

export var CANCEL =
/*#__PURE__*/
sym('CANCEL_PROMISE');
export var CHANNEL_END =
/*#__PURE__*/
sym('CHANNEL_END');
export var CHANNEL_END_TYPE =
/*#__PURE__*/
sym('CHANNEL_END');
export var IO =
/*#__PURE__*/
sym('IO');
export var MATCH =
/*#__PURE__*/
sym('MATCH');
export var MULTICAST =
/*#__PURE__*/
sym('MULTICAST');
export var SAGA_ACTION =
/*#__PURE__*/
sym('SAGA_ACTION');
export var SELF_CANCELLATION =
/*#__PURE__*/
sym('SELF_CANCELLATION');
export var TASK =
/*#__PURE__*/
sym('TASK');
export var TASK_CANCEL =
/*#__PURE__*/
sym('TASK_CANCEL');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga/es/internal/symbols.js
// module id = 122
// module chunks = 58